import { CALL_API } from '../middleware/api';

export const FETCH_ACTIVE_AGENTS = "FETCH_ACTIVE_AGENTS";
export const SUCCESS_ACTIVE_AGENTS = "SUCCESS_ACTIVE_AGENTS";
export const FAILURE_ACTIVE_AGENTS = "FAILURE_ACTIVE_AGENTS";

export function fetchActiveAgents() {
    return {
        type: FETCH_ACTIVE_AGENTS,
        [CALL_API]: {
            endpoint: '/api/settings/agents/active',
            method: 'get',
            types: [SUCCESS_ACTIVE_AGENTS, FAILURE_ACTIVE_AGENTS]
        }
    }
}


// WEBPACK FOOTER //
// ./src/actions/agents.js